// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-who-we-are----member-module---container---3iAyl","card":"src-components-who-we-are----member-module---card---1M6zu","front":"src-components-who-we-are----member-module---front---1b6Ld","back":"src-components-who-we-are----member-module---back---DW6d7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/who-we-are/member.module.scss
// module id = 369
// module chunks = 36434998819415 125193764933041